import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error File is untyped
import imageUrl from 'bender-url!SalesContentIndexUI/images/empty-folder.svg';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Image } from 'foundations-components/transitional/components/Image';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmptyFolder() {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    "data-test-id": "sales-content-index-empty-folder",
    marginBlockStart: "600",
    children: [/*#__PURE__*/_jsx(Image, {
      src: imageUrl,
      responsive: false,
      maxInlineSize: "100px",
      marginBlock: "500"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentIndexUI.emptyState.folder.folderIsEmpty"
      })
    })]
  });
}